(function () {
  function init(root) {
    const rail = root.querySelector('[data-hcfc-carousel]');
    if (!rail) return;
    const prev = root.querySelector('.hcfc__nav--prev');
    const next = root.querySelector('.hcfc__nav--next');

    const page = () => rail.clientWidth; // one page = visible width (4 cards)

    function updateButtons() {
      const maxScroll = rail.scrollWidth - rail.clientWidth - 1;
      prev && (prev.disabled = rail.scrollLeft <= 0);
      next && (next.disabled = rail.scrollLeft >= maxScroll);
    }
    function scrollByPage(dir) {
      rail.scrollBy({ left: dir * page(), behavior: 'smooth' });
    }

    prev && prev.addEventListener('click', () => scrollByPage(-1));
    next && next.addEventListener('click', () => scrollByPage(1));
    rail.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hcfc').forEach(init);
  });
})();
